import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal } from 'synfrastructure';
import { fromJS } from 'immutable';
import VideoPlayer from '../../../common/video/VideoPlayer';
import Icon from '../../../common/icons/Icon';

class DailyExtraModal extends Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
  };
  state = {
    modalVisible: false,
  };
  handleToggleModal = () => {
    this.setState((state, props) => ({
      modalVisible: !state.modalVisible,
    }));
  };
  render() {
    const { video: { image, video } } = this.props;

    return (
      <div className="daily-extra-img__wrapper">
        <button type="button" onClick={this.handleToggleModal}>
          <div className="dash--vid-img" style={{ backgroundImage: `url(${image.location})`}} title>
            <Icon icon="PlayCircle" />
          </div>
        </button>
        {this.state.modalVisible ? (
          <Modal isVisible={this.state.modalVisible} onClose={this.handleToggleModal}>
            <div className="modal__content--alt">
              <div className="video-player__modal-container">
                <VideoPlayer
                  autoplay
                  video={fromJS(video)}
                  poster={image.location}
                  onEnd={this.handleToggleModal}
                />
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default DailyExtraModal;



// WEBPACK FOOTER //
// ./src/subscription/courses/components/DailyExtraModal.js